const userTypes = Object.freeze({
  teacher: 'teacher',
  teacherDemo: 'teacher-demo',
  librarian: 'teacher-librarian',
  independentTeacherBasic: 'independent-teacher',
  independentTeacherLanguage: 'independent-teacher-language',
  independentTeacherPlayers: 'independent-teacher-players',
})
const taskCategories = Object.freeze({
  video: 'video',
  introduction: 'introduction',
  activity: 'activity',
  reflection: 'reflection',
  independentPeerResponse: 'independent_peer_response',
  independentNoResponse: 'independent_no_response',
})

export {
  userTypes,
  taskCategories
}
